import { useCallback, useContext } from "react";

import { notify } from "../../../../utils/notify";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  addServiceContract,
  alterCrValue,
  getCancelLists,
  getListasContract,
  showContract,
  removeService,
  findContractSinglebyCr,
} from "../../../../repositories/qerpapi/erp/faturamento/ContratoRepository";
import { getBillingRules } from "../../../../repositories/qerpapi/v3/faturamento/ContratoRepository";
import { indexTypeContractByCompany } from "../../../../repositories/qerpapi/erp/faturamento//TipoContratosRepository";
import { update as addReimbursableExpense } from "../../../../repositories/qerpapi/erp/faturamento/DespesasReembolsaveisRepository";
import { formatDate } from "../../../../utils/formatDate";
import getDayOfCurrentMonth from "../../../../utils/getDayOfCurrentMonth";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import { ConfigurationContext } from "../contexts/ConfigurationContext";
import { findContasReceber } from "../../../../repositories/qerpapi/erp/financeiro/ContasReceberRepository";
import { findConfigurationV3 } from "../../../../repositories/qerpapi/v3/ConfigurationRepository";
import {
  estornoAbatimento,
  indexAbatimento,
} from "../../../../repositories/qerpapi/erp/financeiro/AbatimentosRepository";
import { indexReajuste } from "../../../../repositories/qerpapi/erp/financeiro/ReajustesRepository";
import { updateRevomeDespesa as updateContasReceber } from "../../../../repositories/qerpapi/erp/financeiro/ContasReceberRepository";
import { findContracItem } from "../../../../repositories/qerpapi/erp/faturamento/ContratoItemRepository";
import { customValidation } from "../../../../utils/validations";
import MaskService from "./../../../../utils/mask/maskService";
import moment from "moment";
import { GlobalVariables } from "../../../../GlobalVariables";
import { GerenciamentoContratoFilterContext } from "../contexts/GerenciamentoContratoFilterContext";

export default function useGerenciamentoContratoListagemController() {
  const {
    client,
    setDisabledButtonSearch,
    setMainLoading,
    initialDate,
    finalDate,
    typeStatus,
    numeroContrato,
    typeContract,
    typePorDataDe,
    setItensTable,
    reasonForCancellation,
    setReasonForCancellation,
    setListTypeContract,
    idTypeContract,
    setClient,
    setTypeStatus,
    setInitialDate,
    setFinalDate,
    setNumeroContrato,
    setTypeContract,
    setTypePorDataDe,
    setIdTypeContract,
  } = useContext(GerenciamentoContratoContext);

  const { configuration, setConfiguration } = useContext(ConfigurationContext);

  const fmtMoney = (value) =>
    parseFloat(value ?? 0).toFixed(configuration?.contract_decimal_size ?? 2);

  const { filtersStorage, setFiltersStorage, setListBillingRules } = useContext(
    GerenciamentoContratoFilterContext
  );

  const { queryParams } = useContext(QueryParamsContext);

  const findContractLogs = async (idContract) => {
    try {
      setMainLoading(true);

      const callback = await showContract({
        empresa_cnpj: queryParams.empresa_cnpj,
        idContract,
        include: "contratologs,contratologs.usuario",
      });

      if (!callback.success)
        return notify("Erro ao buscar registros de alterações.");

      if (!(callback?.data?.contratologs || []).length)
        return notify("Título sem registros de alterações", true, "warning");

      return callback;
    } catch (e) {
      console.error(e);
    } finally {
      setMainLoading(false);
    }
  };

  const initHandleIntesTable = useCallback(async () => {
    try {
      setMainLoading(true);
      setDisabledButtonSearch(true);

      if (filtersStorage) {
        setClient(filtersStorage?.contratoCliente);
        setTypeStatus(filtersStorage?.contratoStatus);
        setInitialDate(
          moment(filtersStorage?.contratoInitialdate).format("YYYY-MM-DD")
        );
        setFinalDate(
          moment(filtersStorage?.contratoFinaldate).format("YYYY-MM-DD")
        );
        setNumeroContrato(filtersStorage?.contratoNumero);
        setTypeContract(filtersStorage?.contratoModalidade);
        setTypePorDataDe(filtersStorage?.contratoDatade);
        setIdTypeContract(filtersStorage?.contratoIdTipo);
      }

      const configurationCall = await findConfigurationV3();
      if (!configurationCall.success)
        return notify("Erro ao buscar as configurações.");

      setConfiguration(configurationCall.data);

      const paramValues = {
        clienteid: filtersStorage?.contratoCliente?.id,
        status: filtersStorage?.contratoStatus?.value ?? "all",
        initialdate: formatDate({
          date:
            filtersStorage?.contratoInitialdate ??
            getDayOfCurrentMonth("first"),
          separator: "-",
          format: "yyyy-mm-dd",
        }),
        finaldate: formatDate({
          date:
            filtersStorage?.contratoFinaldate ?? getDayOfCurrentMonth("last"),
          separator: "-",
          format: "yyyy-mm-dd",
        }),
        numero: filtersStorage?.contratoNumero ?? "",
        modalidade: filtersStorage?.contratoModalidade?.value ?? "all",
        datade: filtersStorage?.contratoDataDe?.value ?? "emissao",
        idtipocontrato: filtersStorage?.contratoIdTipo?.id,
      };

      const [callback, callbackTipos] = await Promise.all([
        getListasContract({
          empresaCnpj: queryParams.empresa_cnpj,
          companyId: queryParams.empresa_id,
          paramValues,
          include: "cliente,tipocontrato",
        }),
        indexTypeContractByCompany({
          empresa_cnpj: queryParams?.empresa_cnpj,
          empresa_id: queryParams?.empresa_id,
          where: { ativo: "S" },
        }),
      ]);

      if (!callback.success || !callbackTipos.success) {
        return notify(callback.message);
      }

      setItensTable(
        callback.data.map((el) => ({
          ...el,
          backgroundColor: el.status === "S" && "#e8e1ff",
          rowError: el.status === "C",
          cliente: el.cliente?.razao || "",
        }))
      );
      setListTypeContract(callbackTipos.data);

      const getAllBillingRules = await getBillingRules();

      if (!getAllBillingRules.success)
        return notify("Erro ao buscar réguas de cobrança.");

      const dataListBillingRules = [];

      getAllBillingRules?.data?.forEach((billingRule) => {
        if (billingRule?.active === true) {
          dataListBillingRules.push({
            value: billingRule?.id,
            label: `${billingRule?.id} - ${billingRule?.name}`,
          });
        }
      });

      setListBillingRules(dataListBillingRules);
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
      setDisabledButtonSearch(false);
    }
  }, [
    setMainLoading,
    setDisabledButtonSearch,
    setItensTable,
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    setListTypeContract,
    setClient,
    setFinalDate,
    setIdTypeContract,
    setInitialDate,
    setNumeroContrato,
    setTypeContract,
    setTypePorDataDe,
    setTypeStatus,
  ]);

  const openLog = async (value, setOpen, setContent) => {
    const logs = await findContractLogs(value?.id);

    if (logs?.data) {
      setContent(logs?.data?.contratologs || null);
      setOpen(true);
    }
  };

  const handleOpenModalCancel = (id, setOpen, setId) => {
    setId(id);
    setOpen(true);
  };

  const handleOpenModalEdicao = ({ numero, id, nfse }, setOpen, setContent) => {
    setContent({ numero, id, nfse });
    setOpen(true);
  };

  const handleSearchContract = async () => {
    try {
      setMainLoading(true);
      setDisabledButtonSearch(true);

      let _initialDate = null;
      let _finalDate = null;

      if (
        (initialDate || finalDate) &&
        !isNaN(new Date(finalDate)) &&
        !isNaN(new Date(initialDate))
      ) {
        _initialDate = initialDate;
        _finalDate = finalDate;
      }

      if ((!_initialDate || !_finalDate) && !client?.id && !numeroContrato) {
        notify(
          "Selecione um Cliente ou informe o Número do Contrato para uma pesquisa sem datas.",
          true,
          "warning"
        );
        return false;
      }

      const paramValues = {
        clienteid: client?.id || null,
        status: typeStatus?.value || null,
        initialdate: _initialDate,
        finaldate: _finalDate,
        numero: numeroContrato,
        modalidade: typeContract?.value || null,
        datade: typePorDataDe?.value || null,
        idtipocontrato: idTypeContract?.id || null,
      };

      const callback = await getListasContract({
        empresaCnpj: queryParams.empresa_cnpj,
        companyId: queryParams.empresa_id,
        paramValues,
        include: "cliente,tipocontrato",
      });

      if (!callback.success) {
        return notify(callback.message);
      }

      setItensTable(
        callback.data.map((el) => ({
          ...el,
          backgroundColor: el.status === "S" && "#e8e1ff",
          rowError: el.status === "C",
          cliente: el.cliente?.razao || "",
        }))
      );
      setFiltersStorage({
        contratoCliente: client || null,
        contratoStatus: typeStatus || null,
        contratoInitialdate: initialDate,
        contratoFinaldate: finalDate,
        contratoNumero: numeroContrato,
        contratoModalidade: typeContract || null,
        contratoDatade: typePorDataDe || null,
        contratoIdTipo: idTypeContract || null,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
      setDisabledButtonSearch(false);
    }
  };

  const requestCancelLists = useCallback(
    async (id, setCrList, setCancelReasonList) => {
      try {
        setMainLoading(true);

        const listsCallback = await getCancelLists({
          contractId: id,
          empresa_cnpj: queryParams.empresa_cnpj,
        });

        if (!listsCallback?.data || !listsCallback?.success)
          return notify("Erro ao buscar listas.");

        setCrList(listsCallback.data.datavencto_cr);
        setCancelReasonList(listsCallback.data.motivos_cancelamento);
      } catch (e) {
        console.error(e);
      } finally {
        setMainLoading(false);
      }
    },
    [queryParams.empresa_cnpj, setMainLoading]
  );

  const findLogsInvoiceByIdCr = async (idCr) => {
    try {
      setMainLoading(true);

      const [abatimentos, reajustes, despesaCr, servicoAvulso] =
        await Promise.all([
          indexAbatimento({
            empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
            id_cr: idCr,
          }),

          indexReajuste({
            empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
            id_cr: idCr,
          }),

          findContasReceber({
            empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
            include: "despesasReembolsaveis",
            id: idCr,
          }),

          findContractSinglebyCr({
            empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
            id_cr: idCr,
          }),
        ]);

      //caso o CR não esteja em carteira
      if (despesaCr.data.situacaodocto !== "00")
        return notify(
          "Título não se encontra mais em carteira",
          true,
          "warning"
        );

      if (
        !abatimentos?.data &&
        !reajustes?.data &&
        !despesaCr?.data &&
        !servicoAvulso?.data
      ) {
        return notify("Título sem registros de alterações", true, "warning");
      }

      let retornoInfo = {
        abatimentos: abatimentos?.data,
        reajustes: reajustes?.data,
        despesas: despesaCr?.data?.despesas_reembolsaveis,
        servicosAvulso: servicoAvulso?.data,
      };

      return retornoInfo;
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const removeDespesa = async (stayDespesa, idDespesa, idCr, setCrRows) => {
    try {
      setMainLoading(true);

      const despesasReembolsaveis = stayDespesa.map((x) => {
        var pivot = x.pivot;
        return {
          ...pivot,
          cancelado:
            x?.pivot?.id_despesa === idDespesa || x?.pivot?.cancelado === 1
              ? 1
              : 0,
        };
      });

      const body = {
        contareceber: {
          despesasReembolsaveis: despesasReembolsaveis,
        },
      };

      const callback = await updateContasReceber({
        empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
        id: idCr,
        body,
      });

      if (callback.success) notify("Despesa removida!", true, "success");
      else notify("Erro ao remover despesa!", true, "error");

      setCrRows((crs) => {
        let crIndex = crs.findIndex((cr) => idCr === cr.id);
        crs[crIndex].valordocto = fmtMoney(callback.data.valordocto);
        return crs;
      });

      return callback.success;
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const abatimentoEstorno = async (idAb, idCr, setCrRows) => {
    try {
      setMainLoading(true);

      const callback = await estornoAbatimento({
        empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
        id: idAb,
        id_cr: idCr,
      });

      if (callback.success) notify("Abatimento estornado!", true, "success");
      else notify("Erro ao estornar abatimento!", true, "error");

      setCrRows((crs) => {
        const crIndex = crs.findIndex((cr) => idCr === cr.id);
        crs[crIndex].valordocto = fmtMoney(
          parseFloat(crs[crIndex].valordocto) +
            (callback.data.vlrabatimento || 0) * -1
        );
        return crs;
      });

      return callback.success;
    } catch (error) {
      console.log(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleSelectReasonForCancellatio = (
    setModalReasonForCancellatioOpen,
    selectedTypeService
  ) => {
    setReasonForCancellation(selectedTypeService[0]);
    setModalReasonForCancellatioOpen(false);
  };

  const removeServicoAvulso = async (
    id,
    idCr,
    setCrRows = () => {},
    content,
    setContent = () => {}
  ) => {
    try {
      setMainLoading(true);

      const body = {
        servicos: [
          {
            contratoitem_id: id,
            motivocancelamento_id: reasonForCancellation?.id,
            usuario_id: queryParams?.usuario_id,
          },
        ],
        contasreceber: [idCr],
      };

      const callback = await removeService({
        empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
        body,
      });

      if (callback.success)
        notify("Serviço avulso cancelado!", true, "success");
      else notify("Erro ao cancelar serviço avulso!", true, "error");

      const contractItem = await findContracItem({
        empresa_cnpj: queryParams.empresa_cnpj.replace(/[^\d]+/g, ""),
        id: id,
      });

      if (callback.success) {
        setCrRows((crs) => {
          const crIndex = crs.findIndex((cr) => idCr === cr.id);
          crs[crIndex].valordocto = fmtMoney(
            parseFloat(crs[crIndex].valordocto) -
              (contractItem.data.valortotal || 0)
          );
          return crs;
        });
      } else {
        notify("Erro ao consultar novo valor total!", true, "error");
      }

      return callback.success;
    } catch (error) {
      console.log(error);
    } finally {
      setMainLoading(false);
    }
  };

  const getContasReceberByContract = useCallback(
    async (
      id,
      setTable = () => {},
      setLoading = () => {},
      situation = null,
      firstDate = null,
      finalDate = null
    ) => {
      if (!queryParams?.empresa_cnpj || !queryParams?.empresa_id)
        return notify("Não foram encontradas as informações sobre a empresa.");

      try {
        setLoading(true);
        let whereIn = {};
        let whereMoreEqual = {};
        let whereLessEqual = {};
        if (firstDate) {
          whereMoreEqual = { datavencto: [firstDate] };
        }

        if (finalDate) {
          whereLessEqual = { datavencto: [finalDate] };
        }

        if (situation && situation !== "0") {
          switch (situation) {
            case "1":
              whereIn = {
                situacaodocto: [
                  GlobalVariables.situacaoReceber.carteira,
                  GlobalVariables.situacaoReceber.cobranca,
                  GlobalVariables.situacaoReceber.cartorio,
                  GlobalVariables.situacaoReceber.protestado,
                  GlobalVariables.situacaoReceber.liquidadoParcialmente,
                  GlobalVariables.situacaoReceber.negociando,
                  GlobalVariables.situacaoReceber.devolvidoBanco,
                ],
              };
              break;
            case "2":
              whereIn = {
                situacaodocto: [
                  GlobalVariables.situacaoReceber.carteira,
                  GlobalVariables.situacaoReceber.cobranca,
                  GlobalVariables.situacaoReceber.cartorio,
                  GlobalVariables.situacaoReceber.protestado,
                  GlobalVariables.situacaoReceber.liquidadoParcialmente,
                  GlobalVariables.situacaoReceber.negociando,
                ],
              };
              break;
            case "3":
              whereIn = {
                situacaodocto: [
                  GlobalVariables.situacaoReceber.liquidadoParcialmente,
                  GlobalVariables.situacaoReceber.liquidadoTotalmente,
                ],
              };
              break;
            default:
              whereIn = { situacaodocto: [situation] };
              break;
          }
        }
        const callback = await findContasReceber({
          empresa_cnpj: queryParams.empresa_cnpj,
          whereEqual: { idcontrato: id },
          wherein: whereIn,
          whereMoreEqual,
          whereLessEqual,
          include: "situacaoreceber",
        });

        if (!callback.success || !callback.data)
          return notify(
            "Erro ao buscar os Contas a Receber vinculados a esse contrato."
          );

        setTable(callback?.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    },
    [queryParams.empresa_cnpj, queryParams.empresa_id]
  );

  const handleSubmit = async (
    action,
    body,
    setErrors,
    setTable,
    setLoading
  ) => {
    let toValidate = [];
    let idDespesa = body.id_dp;
    delete body.id_dp;

    if (action === "dp") {
      toValidate = [
        { key: "contasReceber", condition: body.contasReceber?.length > 0 },
        {
          key: "value",
          condition: parseFloat(body.contasReceber[0]?.valor) > 0.0,
        },
      ];
    } else {
      toValidate = [
        { key: "contasReceber", condition: body.contasreceber?.length > 0 },
        {
          key: "value",
          condition: parseFloat(body.valor) > 0.0,
        },
      ];
    }

    if (action === "add")
      toValidate.push({ key: "service", condition: body.servico_id });

    const validation = customValidation(toValidate);

    if (validation.error) {
      setErrors(validation.errorsValidation);

      if (validation.errorsValidation.contasReceber)
        notify(
          "Você precisa selecionar ao menos um Contas a Receber para realizar a operação."
        );

      return false;
    }

    try {
      setLoading(true);

      let callback;
      if (action === "add")
        callback = await addServiceContract({
          empresa_cnpj: queryParams.empresa_cnpj,
          body,
        });
      else if (action === "dp")
        callback = await addReimbursableExpense({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: idDespesa,
          body,
        });
      else
        callback = await alterCrValue({
          empresa_cnpj: queryParams.empresa_cnpj,
          body,
        });

      if (!callback.success) {
        notify(
          callback.message ??
            "Ocorreu um erro ao realizar a operação. Tente novamente em alguns minutos"
        );

        return false;
      }
      if (action === "dp") {
        setTable((current) =>
          current.map((cr) => ({
            ...cr,
            ...(body?.contasReceber.map((e) => e.id_cr).includes(cr.id) && {
              valordocto: sumCrValueAfterRequisiton(
                body.valor_tipo === "porcentagem",
                parseFloat(cr.valordocto),
                parseFloat(body.contasReceber[0].valor),
                action,
                body.quantidade || 1
              ),
              ...(sumCrValueAfterRequisiton(
                body.valor_tipo === "porcentagem",
                parseFloat(cr.valordocto),
                parseFloat(body.contasReceber[0].valor),
                action,
                body.quantidade || 1
              ) === "0.00" && {
                situacaodocto: "50",
                rowError: true,
                notSelectable: true,
              }),
            }),
          }))
        );
      } else {
        setTable((current) =>
          current.map((cr) => ({
            ...cr,
            ...(body?.contasreceber.map((e) => e.id).includes(cr.id) && {
              valordocto: sumCrValueAfterRequisiton(
                body.valor_tipo === "porcentagem",
                parseFloat(cr.valordocto),
                parseFloat(body.valor),
                action,
                body.quantidade || 1
              ),
              ...(sumCrValueAfterRequisiton(
                body.valor_tipo === "porcentagem",
                parseFloat(cr.valordocto),
                parseFloat(body.valor),
                action,
                body.quantidade || 1
              ) === "0.00" && {
                situacaodocto: "50",
                rowError: true,
                notSelectable: true,
              }),
            }),
          }))
        );
      }

      let operations = {
        A: "Abatimento",
        add: "Inclusão de serviço avulso",
        dp: "Inclusão de Despesas Reembolsáveis",
      };

      notify(operations[action] + " realizado com sucesso!", true, "success");

      return true;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const sumCrValueAfterRequisiton = (
    isPercentage,
    oldValue,
    toSumValue,
    action,
    quantity
  ) => {
    const oldVal = parseFloat(oldValue) || 0;
    const sumVal = parseFloat(toSumValue) || 0;
    const qty = parseFloat(quantity) || 1;
    let result = 0;

    if (action === "A") {
      result = isPercentage
        ? oldVal - (sumVal / 100) * oldVal
        : oldVal - sumVal;
    } else {
      result = isPercentage
        ? oldVal + (sumVal / 100) * oldVal
        : oldVal + sumVal * qty;
    }

    return result.toFixed(2);
  };

  const resetInputs = ({
    setSelectedAccounts,
    setUserValue,
    setIsPercentage,
    setReason,
    setQuantity,
    setService,
    setExpense,
    setComplement,
  }) => {
    setSelectedAccounts([]);
    setUserValue(`0,${"0".repeat(configuration?.contract_decimal_size || 2)}`);
    setIsPercentage(false);
    setReason("");
    setQuantity(1);
    setService(null);
    setExpense(null);
    setComplement("");
  };

  const handleSelectedService = (setOpen, selected, setService) => {
    const item = selected[0];
    if (!item) return;

    setService(item);
    setOpen(false);
  };

  const handleSelectedExpenses = (setOpen, selected, setExpense) => {
    const item = selected[0];
    if (!item) return;

    setExpense(item);
    setOpen(false);
  };

  const handleSelectedExpenseService = (
    setOpen,
    selected,
    setExpenseService
  ) => {
    const item = selected[0];
    if (!item) return;

    setExpenseService(item);
    setOpen(false);
  };

  // Função que gerencia os submits
  const handleSubmitByButton = async (
    context,
    {
      id,
      userValue,
      selectedAccounts,
      selectedAction,
      isPercentage,
      reason,
      quantity,
      service,
      expenseService,
      expense,
    },
    {
      setSelectedAccounts,
      setUserValue,
      setIsPercentage,
      setReason,
      setQuantity,
      setService,
      setErrors,
      setCrRows,
      setLoading,
      setExpense,
      setExpenseService,
      setComplement,
    }
  ) => {
    const body = {
      // Campos padrão que vão nas requisições de reajuste e avulso
      ...(context !== "despesas" && {
        contrato_id: id,
        valor: MaskService.removeMaskDecimal(
          userValue,
          configuration?.contract_decimal_size || 2
        ),
        contasreceber: selectedAccounts.map((e) => ({ id: e.id })),
        usuario_id: queryParams.usuario_id,
      }),
      // Condição para adicionar o resto dos capos baseado no contexto do botão
      ...(context === "readjust"
        ? {
            acao: selectedAction?.value,
            valor_tipo: isPercentage ? "porcentagem" : "moeda",
            motivo: reason,
          }
        : context === "despesas"
        ? {
            id_dp: expense?.id,
            usuario_id: queryParams.usuario_id,
            contasReceber: selectedAccounts.map((e) => ({
              id_cr: e.id,
              valor: MaskService.removeMaskDecimal(
                userValue,
                configuration?.contract_decimal_size || 2
              ),
              id_servico: expenseService?.id,
              cancelado: 0,
            })),
          }
        : {
            servico_tipo: "avulso",
            quantidade: quantity,
            servico_id: service?.id,
            edicao_financeira: true,
          }),
    };

    let success = await handleSubmit(
      selectedAction?.value,
      body,
      setErrors,
      setCrRows,
      setLoading
    );

    if (success)
      resetInputs({
        setSelectedAccounts,
        setUserValue,
        setIsPercentage,
        setReason,
        setQuantity,
        setService,
        setExpense,
        setComplement,
      });
  };

  return {
    handleSearchContract,
    initHandleIntesTable,
    findContractLogs,
    requestCancelLists,
    getContasReceberByContract,
    openLog,
    handleOpenModalCancel,
    handleOpenModalEdicao,
    handleSubmit,
    resetInputs,
    handleSelectedService,
    handleSelectedExpenses,
    handleSelectedExpenseService,
    handleSubmitByButton,
    findLogsInvoiceByIdCr,
    removeDespesa,
    abatimentoEstorno,
    handleSelectReasonForCancellatio,
    removeServicoAvulso,
  };
}
